import { Box, Button, Typography } from '@mui/material';
import { audioControlsStyles } from './styles';

interface AudioControlsProps {
  isProcessingAudio: boolean;
  isPlaying: boolean;
  currentTime: number;
  audioElement: HTMLAudioElement | null;
  onPlayPause: () => void;
  onPlayAgain: () => void;
}

const AudioControls: React.FC<AudioControlsProps> = ({
  isProcessingAudio,
  isPlaying,
  currentTime,
  audioElement,
  onPlayPause,
  onPlayAgain,
}) => {
  return (
    <>
      {/* Audio Control Buttons */}
      {!isProcessingAudio && (
        <Box sx={audioControlsStyles.buttonContainer}>
          <Button
            variant="text"
            onClick={onPlayPause}
            sx={audioControlsStyles.playPauseButton}
          >
            {isPlaying
              ? '⏸️ Pause Audio'
              : currentTime > 0
                ? '▶️ Continue'
                : '🎵 Listen Audio'}
          </Button>

          {audioElement && (
            <Button
              variant="text"
              onClick={onPlayAgain}
              sx={audioControlsStyles.playAgainButton}
            >
              🔄 Play Again
            </Button>
          )}
        </Box>
      )}

      {isProcessingAudio && (
        <Typography variant="body2" sx={audioControlsStyles.processingText}>
          Processing audio...
        </Typography>
      )}
    </>
  );
};

export { AudioControls };
